export { default } from "./Confirm";
